import { render } from "./my-dashboard.vue?vue&type=template&id=65d36cf2&scoped=true"
import script from "./my-dashboard.vue?vue&type=script&lang=js"
export * from "./my-dashboard.vue?vue&type=script&lang=js"

import "./my-dashboard.vue?vue&type=style&index=0&id=65d36cf2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d36cf2"]])

export default __exports__